<template>
    <div class="components-scrollExpert" >
        <div id="cont" class="cont" >
            <div class="item" v-for='(item,index) in list_data' :key="index">
                <div class="info">
                    <div class="avatar">
                        <img :src="item.img_avatar_full">
                    </div>
                    <div class="data">
                        <div class="top">{{ item.name }}</div>
                        <div class="bottom">{{ item.mobile||'---' }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        dataList:{
            type : Array,
            default:function(){
                return [];
            }
        }
    },
    data(){
        return {
            "list_data" : [
                {name:"马云"},
            ],
            "animate"   : false,
            
            "config"    : {
                "base_scroll":2,

                "scroll":0,
                
            },
            "timer":null,
        }
    },
    created(){
        this.list_data = this.fillArray((this.dataList || []).slice(0));
    },
    watch(){
        dataList:(val)=>{
            this.list_data = this.fillArray((val || []).slice(0));
        }
    },
    mounted(){
        this.$nextTick(function(){
            this.timer = setInterval(()=>{
                console.log("is run");
                this.handelScroll();
            },30);
            
        });
    },
    destroyed(){
        clearInterval(this.timer);
    },
    methods: {
        fillArray(arr){
            var doFill = (a)=>{
                if(a.length==0){
                    return a;
                }
                if( a.length < 20 ){
                    var r = a.slice(0);
                    a.forEach(item => {
                        r.push(item);
                    });
                    return doFill(r);
                }else{
                    return a;
                }
            }
            
            return doFill(arr);
        },
        handelScroll(){
            var config = this.config;
            var dom  = document.querySelector(".cont")
            var first = dom.children[0];
            // console.log(first.offsetHeight , config.scroll );
            if( first.offsetHeight <= config.scroll  ){
                first = dom.children[0].cloneNode(true);
                var h = first.offsetHeight;
                dom.children[0].remove();
                this.config.scroll = 0;
                // first.style.marginTop = `-0px`;
                document.querySelector(".cont").appendChild(first);
                document.querySelector(".cont").lastChild.style.marginTop = `-0px`;
                
                this.config.scroll = this.config.scroll - h;
            }else{
                this.config.scroll += config.base_scroll;
                first.style.marginTop = `-${this.config.scroll}px`;
            }
            // setTimeout(()=>{
            //     this.handelScroll();
            // },10);
        }
    }
}
</script>

<style lang="less" scoped>
.components-scrollExpert{
    width:100%;height:300px;overflow: hidden;
    .cont{
        height: 280px;overflow: hidden;

        .item{
            transition: all 0.1s;
            text-align: center;

            .info{
                display: inline-block;
                width: 100%;
                padding:10px 0px;
                .avatar,.data{
                    display: inline-block;
                    vertical-align: middle;
                }
                .avatar{
                    width:40px;height:40px;border-radius: 40px;overflow: hidden;
                    box-shadow: 1px 1px 10px rgba(0,0,0,0.5);
                    img{
                        width:100%;
                        height: 100%;
                    }
                }
                .data{
                    margin-left: 20px;
                    // max-width: calc(100% - 40px - 20px);
                    width: 150px;
                    text-align: left;
                    .top{
                        font-weight: bold;
                        font-size: 16px;
                        
                    }
                    .bottom{
                        font-size: 16px;
                        color:#a2a2a2;
                    }
                }
            }
        }
    }
}
</style>